// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"bfaa330b","977":"aab6afa5"}[chunkId] + ".chunk.js";
};